import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';

export const List = ({
  params,
  filter
}: Types.IApi.Application.Request): AxiosPromise<{ data: { application_list: Types.IApi.Application.Response[] } }> => {
  return http.request.get<{ data: { application_list: Types.IApi.Application.Response[] } }>(`/application/list`, {
    params: {
      ...filter,
      page: params.page - 1,
      size: params.limit
    }
  });
};

export const Single = ({ id }): AxiosPromise<{ data: Types.IApi.Application.Response }> => {
  return http.request.get<{ data: Types.IApi.Application.Response }>(`/application/view?id=${id}`);
};

export const RefundJournalApi = ({ id }: { id: number }): AxiosPromise<Types.IEntity.RefundJournal[]> =>
  http.request.get(`/external/refund-new/online/${id}`);

export const RefundDelete = ({ id }: { id: number }): AxiosPromise<Types.IEntity.RefundJournal> =>
  http.request.put(`/external/refund-new/online-cancel/${id}`);
